module.exports = __webpack_public_path__ + "img/ContainerLifter.61fea82f.png";